import Page from "@jumbo/shared/Page";
import InventoryReportRouteMiddleware from "./middleware/auth/inventoryReport";
import InventoryReport from "app/pages/InventoryReport";

export const inventoryReportRoutes = [
  {
    middleware: [
      {
        element: InventoryReportRouteMiddleware,
        fallbackPath: "/dashboard",
      },
    ],
    routes: [
      {
        path: "/dashboard/inventory-report",
        element: (
          <Page component={InventoryReport} layout={"vertical-default"} />
        ),
      },
    ],
  },
];
